import { t } from "i18next";
import z from "zod";

import { I18nKeyType } from "@/i18n";

export const searchFormSchema = z.object({
  search: z.string().trim().optional(),
});
export type SearchFormType = z.infer<typeof searchFormSchema>;

export type OptionType = {
  label: string;
  value: string;
};

export const requiredStringSchema = z
  .string({
    error: t("common:validation.requiredField"),
  })
  .trim()
  .min(1, t("common:validation.requiredField"));

// A missing (undefined/null) value fails as a *fatal* `invalid_type` issue, which
// aborts object parsing and skips the cross-field home/mailing address `.refine()`
// checks below — hiding the address error. Coercing to "" makes it a non-fatal
// format error so the address refinements always evaluate.
export const coerceMissingToEmptyString = (value: unknown) => value ?? "";

export const fallbackToEmptyString = (messageI18nKey: I18nKeyType) =>
  z.preprocess(
    coerceMissingToEmptyString,
    z.string().min(1, { message: t(messageI18nKey) }),
  );
